import { type GuideMetadata } from '../types';

const metadata: Readonly<GuideMetadata> = Object.freeze({
  name: 'Express',
  description:
    'Express is a minimal and flexible Node.js web application framework that provides a robust set of features for web and mobile applications.',
  target: 'API',
});

export default metadata;
